/**
 *  获取location.search中某一项的值
 * @param {string} name 要获取search中的key
 */
export const GetSearchValue = function (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

/**
 *  获取location.hash中某一项的值
 * @param {string} name 要获取query中的key
 */
export const GetHashValue = function (name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let index = window.location.hash.indexOf('?')
  let r = window.location.hash.substr(index + 1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}
